import React from 'react'
import { shallow } from 'enzyme'

import { NotifyBankToReviewModal } from '../../modals/NotifyBankToReviewModal'

describe('NotifyBankToReviewModal', () => {
  let wrapper, props, result, instance
  beforeEach(() => {
    props = {
      followers: [
        {
          rid: 123,
          name: 'Billfloat Admin'
        }
      ],
      adminsWithPermission: [
        {
          rid: 234,
          name: 'SmartBiz Admin'
        }
      ],
      isBankUser: true,
      toggleModal: jest.fn(),
      successResponse: jest.fn(),
      notifyToReview: () => {
        result = 'notifyToReview'
      },
    },
    wrapper = shallow(<NotifyBankToReviewModal {...props} />)
    instance = wrapper.instance()
  })

  it('should set the default state for content to empty string', () => {
    expect(wrapper.state('content').length).toEqual(0);
    expect(wrapper.state('isButtonDisabled')).toBeFalsy();
    expect(wrapper.state('recipientIds')[0]).toEqual(props.followers[0].rid)
  })
  describe('#onTypeaheadSearch', () => {
    it('should set the receiptIds based on the selected list', () => {
      const selected = ['SmartBiz Admin']
      instance.onTypeaheadSearch(selected)
      expect(wrapper.state('recipientIds')[0]).toEqual(props.adminsWithPermission[0].rid)
    })
  })
  describe('#onContentChange', () => {
    it('should change the state of the content', () => {
      const event = {
        target: {
          value: 'content'
        }
      }
      instance.onContentChange(event);
      expect(wrapper.state('content')).toEqual(event.target.value)
    })
  })
  describe('#render', () => {
    it('should not have maxLength prop added to TextArea', () => {
      const textarea = wrapper.find('NotifyBankToReviewModal__TextArea').at(0)
      expect(textarea.props().maxLength).toBeUndefined();
    })
  })
})